import { useState as d, useEffect as P, useCallback as m } from "react";
const p = ".", f = (e) => `${e}${p}`, u = (e, n) => {
  const a = f(n), t = new URLSearchParams();
  return new URLSearchParams(e).forEach((r, s) => {
    s.startsWith(a) && t.append(s.slice(a.length), r);
  }), t;
}, S = (e, n, a) => {
  const t = f(n), r = new URLSearchParams();
  new URLSearchParams(e).forEach((c, o) => {
    o.startsWith(t) || r.append(o, c);
  }), a.forEach((c, o) => {
    r.append(`${t}${o}`, c);
  });
  const s = r.toString();
  return s ? `?${s}` : "";
}, l = (e) => {
  const [n, a] = d(() => new URLSearchParams()), [t, r] = d(!1);
  P(() => {
    a(u(window.location.search, e)), r(!0);
  }, [e]);
  const s = m(
    (c) => {
      if (typeof window > "u")
        return;
      const { pathname: o, search: i, hash: w } = window.location, h = S(i, e, c);
      h !== i && window.history.replaceState(window.history.state, "", `${o}${h}${w}`);
    },
    [e]
  );
  return { restoredParams: n, isRestored: t, setParams: s };
};
export {
  u as readNamespacedParams,
  l as useSearchParamsState,
  S as writeNamespacedParams
};
